import type { CanClaimTripsDetailDefaults } from "../types/CanClaimTripsDetailDefaults";

export const canClaimTripsDetailDefaultValues: CanClaimTripsDetailDefaults = {
    canSeeAssignedOrders: false,
    maxOrderPrice: 200,
    maxDaysBeforeTrip: 2,
    countryIdsForClaiming: [],
};
